import {
  LOGIN_REQUESTING,
  CLEAR_MESSAGES,
} from './constants'
  
// In order to perform an action of type LOGIN_REQUESTING
// we need an email and password
export const loginRequest = (postData, history, referUrl) => {
  return {
    type: LOGIN_REQUESTING,
    payload: postData,
    history,
    referUrl
  }
}

export const clearMessages = () => {
  return {
    type: CLEAR_MESSAGES,
  }
}
export default loginRequest


// WEBPACK FOOTER //
// ./src/views/Pages/Login/actions.js